import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import DynamicForm from "../../../components/dynamicscreens/DynamicForm";
import { withRouter } from "../../../components/withRouter";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";
import { googleAddressUrl, googleApiKey } from "../../../config/Url";
import { ManagerJson } from "../../../DynamicFormsJson/MastersJSON/manager";
import { ManagerJsonForFoodrite } from "../../../DynamicFormsJson/MastersJSON/managerJsonForFoodrite";
import { getAreaByTalukaPostBodyUpdated } from "../../../Slice/area.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getRegionNew, getZoneByRegion } from "../../../Slice/region.slice";
import {
	getAreaByStockStakeHolderTypeIdAndZoneIds,
	getAreaByStockStakeHolderTypeIdAndZoneIdsEdit,
	getSalesExecutiveByAreaAndStockHolderType,
	getSalesExecutiveByAreaAndStockHolderTypeForClaim,
	getSalesExecutiveByAreaAndStockHolderTypeForLeave,
} from "../../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import {
	getAboveOrderAndSelfById,
	getAboveOrderById,
	getStockStakeHolderType,
} from "../../../Slice/stockStakeHolderType.slice";
import { getTalukaByDistrictPost } from "../../../Slice/taluka.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import { apiGet } from "../../../utils/api_service";
import LocationRow from "../../../utils/locationRow";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import GoogleMapForAreaExploration from "../../Request For Distributor/GoogleMapForAreaExploration";

class ManagerForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLog: true,
			openMap: false,
			showLocation: false,
			latitude: "",
			longitude: "",
			locationValue: "1",
			address: "",
			dynamicMasterData: {
				regionDetail: this.props.regionList?.region,
				stateDetail: this.props.stateList?.stateByRegion,
				zoneDetail: this.props.zoneList?.zoneByRegionId,
				districtDetail: this.props.districtList?.districtByZone,
				talukaDetail: this.props.talukaList?.talukaByDistrict,
				areaDetail: this.props.areaList?.areaByTaluka,
				stockStakeHolderTypeDetail:
					this.props.stockStakeHolderTypeList?.stockStakeHolderType,
			},
			stockStakeHolderTypeId: "",
			stockStakeHolderTypeUserType: "",
			isShowSalesTeamModuleOverTheManager: 0,
			isShowSalesTeamHomeAddress: 0,
		};
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.regionList !== nextProps.regionList) {
			if (this.props.regionList?.region !== nextProps.regionList?.region) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						regionDetail: nextProps.regionList?.region,
					},
				});
			}
		}

		if (
			this.props.stockStakeHolderTypeList !== nextProps.stockStakeHolderTypeList
		) {
			if (
				this.props.stockStakeHolderTypeList?.stockStakeHolderType !==
				nextProps.stockStakeHolderTypeList?.stockStakeHolderType
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						stockStakeHolderTypeDetail:
							nextProps.stockStakeHolderTypeList?.stockStakeHolderType,
					},
				});
			}
		}

		if (
			this.props.stockStakeHolderTypeList !== nextProps.stockStakeHolderTypeList
		) {
			if (
				this.props.stockStakeHolderTypeList?.aboveOrderById !==
				nextProps.stockStakeHolderTypeList?.aboveOrderById
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						authorityTypeDetail:
							nextProps.stockStakeHolderTypeList?.aboveOrderById,
					},
				});
			}
		}

		if (this.props.salesExecutiveList !== nextProps.salesExecutiveList) {
			if (
				this.props.salesExecutiveList
					?.salesExecutiveByAreaAndStockHolderType !==
				nextProps.salesExecutiveList?.salesExecutiveByAreaAndStockHolderType
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						authorityDetail:
							nextProps.salesExecutiveList
								?.salesExecutiveByAreaAndStockHolderType,
					},
				});
			}
		}

		if (this.props.salesExecutiveList !== nextProps.salesExecutiveList) {
			if (
				this.props.salesExecutiveList
					?.salesExecutiveByAreaAndStockHolderTypeForLeave !==
				nextProps.salesExecutiveList
					?.salesExecutiveByAreaAndStockHolderTypeForLeave
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						leaveAuthorityDetail:
							nextProps.salesExecutiveList
								?.salesExecutiveByAreaAndStockHolderTypeForLeave,
					},
				});
			}
		}

		if (this.props.salesExecutiveList !== nextProps.salesExecutiveList) {
			if (
				this.props.salesExecutiveList
					?.salesExecutiveByAreaAndStockHolderTypeForClaim !==
				nextProps.salesExecutiveList
					?.salesExecutiveByAreaAndStockHolderTypeForClaim
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						claimAuthorityDetail:
							nextProps.salesExecutiveList
								?.salesExecutiveByAreaAndStockHolderTypeForClaim,
					},
				});
			}
		}

		if (this.props.stateList !== nextProps.stateList) {
			if (
				this.props.stateList?.stateByRegion !==
				nextProps.stateList?.stateByRegion
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						stateDetail: nextProps.stateList?.stateByRegion,
					},
				});
			}
		}

		if (this.props.zoneList !== nextProps.zoneList) {
			if (
				this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						zoneDetail: nextProps.zoneList?.zoneByState,
					},
				});
			}
		}

		if (this.props.districtList !== nextProps.districtList) {
			if (
				this.props.districtList?.districtByZone !==
				nextProps.districtList?.districtByZone
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						districtDetail: nextProps.districtList?.districtByZone,
					},
				});
			}
		}

		if (this.props.talukaList !== nextProps.talukaList) {
			if (
				this.props.talukaList?.talukaByDistrict !==
				nextProps.talukaList?.talukaByDistrict
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						talukaDetail: nextProps.talukaList?.talukaByDistrict,
					},
				});
			}
		}

		if (this.props.areaList !== nextProps.areaList) {
			if (
				this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
			) {
				this.setState({
					dynamicMasterData: {
						...this.state.dynamicMasterData,
						areaDetail: nextProps.areaList?.areaByTaluka,
					},
				});
			}
		}
	}

	async componentDidMount() {
		const {
			getStockStakeHolderType,
			getRegionNew,
			showLoador,
			showNotification,
		} = this.props;
		const { dynamicMasterData } = this.state;
		if (navigator.onLine) {
			const isShowSalesTeamModuleOverTheManager =
				localStorage.getItem("isShowSalesTeamModuleOverTheManager") &&
				localStorage.getItem("isShowSalesTeamModuleOverTheManager") !== null
					? localStorage.getItem("isShowSalesTeamModuleOverTheManager")
					: 0;

			let isShowSalesTeamHomeAddress =
				localStorage.getItem("isShowSalesTeamHomeAddress") == 1;

			this.setState({
				isShowSalesTeamModuleOverTheManager,
				isShowSalesTeamHomeAddress,
			});

			if (isShowSalesTeamHomeAddress && this.props.params.id == undefined) {
				this.setState({
					showLocation: true,
				});
				this.getCurrentLocationData();
			}

			showLoador({ loador: true });
			await getRegionNew().then(({ success }) => {
				showLoador({ loador: false });
				if (!success) {
					showNotification({ msg: serverMsg, severity: "error" });
				}
			});

			let userTypeIdsToSend =
				isShowSalesTeamModuleOverTheManager == 1 ? "3,4" : 3;
			showLoador({ loador: true });
			await getStockStakeHolderType({ userTypeIds: userTypeIdsToSend }).then(
				({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				},
			);
		} else {
			this.props.showNotification({ msg: noInternetMsg, severity: "error" });
		}
	}

	setDataToForm = (data) => {
		const { latitude, longitude } = this.state;
		if (latitude == "" && longitude == "") {
			this.setState({
				latitude: data.latitude,
				longitude: data.longitude,
				address: data.homeAddress,
			});
		}
	};

	getListById = async (data) => {
		const { stockStakeHolderTypeId, dynamicMasterData } = this.state;
		const {
			getAreaByStockStakeHolderTypeIdAndZoneIds,
			getAreaByStockStakeHolderTypeIdAndZoneIdsEdit,
			getZoneByRegion,
			getAboveOrderAndSelfById,
			getAboveOrderById,
			getSalesExecutiveByAreaAndStockHolderType,
			getSalesExecutiveByAreaAndStockHolderTypeForLeave,
			getSalesExecutiveByAreaAndStockHolderTypeForClaim,
			getStateByRegion,
			getZoneByState,
			getDistrictByZone,
			getTalukaByDistrictPost,
			getAreaByTalukaPostBodyUpdated,
			showLoador,
			showNotification,
		} = this.props;
		if (navigator.onLine) {
			if (data.stockStakeHolderType && data.stockStakeHolderType.id != "") {
				const filterData = dynamicMasterData.stockStakeHolderTypeDetail.filter(
					(row) => row.id == data.stockStakeHolderType.id,
				);

				let stockStakeHolderTypeUserType =
					filterData.length != 0 &&
					filterData[0].userType !== null &&
					filterData[0].userType.id !== null
						? filterData[0].userType.id
						: "";

				this.setState({
					stockStakeHolderTypeId: data.stockStakeHolderType.id,
					stockStakeHolderTypeUserType,
				});

				if (stockStakeHolderTypeUserType == 4) {
					showLoador({ loador: true });
					await getAboveOrderById({
						typeId: data.stockStakeHolderType.id,
					}).then(({ response, success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						} else {
							this.setState({
								dynamicMasterData: {
									...this.state.dynamicMasterData,
									leaveAuthorityTypeDetail: response,
									claimAuthorityTypeDetail: response,
								},
							});
						}
					});
				} else {
					showLoador({ loador: true });
					await getAboveOrderAndSelfById({
						typeId: data.stockStakeHolderType.id,
					}).then(({ response, success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						} else {
							this.setState({
								dynamicMasterData: {
									...this.state.dynamicMasterData,
									leaveAuthorityTypeDetail: response,
									claimAuthorityTypeDetail: response,
								},
							});
						}
					});
				}
			}

			if (data.reportingManagerTypeId && data.areaIds) {
				let saveData = {
					stockStakeHolderTypeId: data.reportingManagerTypeId,
					areaIds: data.areaIds,
				};
				showLoador({ loador: true });
				await getSalesExecutiveByAreaAndStockHolderType({
					dataJson: saveData,
				}).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}

			if (data.leaveAuthorityTypeId && data.areaIds) {
				let saveData = {
					stockStakeHolderTypeId: data.leaveAuthorityTypeId,
					areaIds: data.areaIds,
				};

				showLoador({ loador: true });
				await getSalesExecutiveByAreaAndStockHolderTypeForLeave({
					dataJson: saveData,
				}).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}

			if (data.claimAuthorityTypeId && data.areaIds) {
				let saveData = {
					stockStakeHolderTypeId: data.claimAuthorityTypeId,
					areaIds: data.areaIds,
				};

				showLoador({ loador: true });
				await getSalesExecutiveByAreaAndStockHolderTypeForClaim({
					dataJson: saveData,
				}).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}

			if (
				data.zoneIds &&
				data.stockStakeHolderType &&
				data.stockStakeHolderType.id != ""
			) {
				if (this.props.params.id) {
					showLoador({ loador: true });
					await getAreaByStockStakeHolderTypeIdAndZoneIdsEdit({
						saleExcId: this.props.params.id,
						StockStakeHolderTypeId: data.stockStakeHolderType.id,
						zoneIds: data.zoneIds,
					}).then(({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					});
				} else {
					showLoador({ loador: true });
					await getAreaByStockStakeHolderTypeIdAndZoneIds({
						StockStakeHolderTypeId: data.stockStakeHolderType.id,
						zoneIds: data.zoneIds,
					}).then(({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					});
				}
			}
			if (data.regionIds && data.regionIds != "") {
				showLoador({ loador: true });
				await getStateByRegion({ regionIds: data.regionIds }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}

			if (data.stateId && data.stateId != "") {
				showLoador({ loador: true });
				await getZoneByState({ stateIds: data.stateId }).then(({ success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({ msg: serverMsg, severity: "error" });
					}
				});
			}

			if (data.zoneIds && data.zoneIds != "") {
				showLoador({ loador: true });
				await getDistrictByZone({ zoneIds: data.zoneIds }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}

			if (data.districtIds && data.districtIds != "") {
				let districtIdsByPost = {
					districtIds:
						typeof data.districtIds === "string"
							? data.districtIds.split(",")
							: data.districtIds,
				};

				showLoador({ loador: true });
				await getTalukaByDistrictPost({ districtIds: districtIdsByPost }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}

			if (data.talukaIds && data.talukaIds != "") {
				let talukaJson = {
					talukaIds:
						typeof data.talukaIds === "string"
							? data.talukaIds.split(",")
							: data.talukaIds,
				};

				showLoador({ loador: true });
				await getAreaByTalukaPostBodyUpdated({ talukaIds: talukaJson }).then(
					({ success }) => {
						showLoador({ loador: false });
						if (!success) {
							showNotification({ msg: serverMsg, severity: "error" });
						}
					},
				);
			}
		} else {
			this.props.showNotification({ msg: noInternetMsg, severity: "error" });
		}
	};

	callBeforeSaveMethod = async (dataToSave, editData) => {
		if (
			Object.keys(editData).length == 0 ||
			(Object.keys(editData).length != 0 &&
				editData.employeeCode != dataToSave.employeeCode)
		) {
			const { showLoador, showNotification } = this.props;
			if (navigator.onLine) {
				showLoador({ loador: true });
				const response = await apiGet({
					url:
						ManagerJson.apiBaseURL +
						"/employee-code-exist-or-not?employeeCode=" +
						dataToSave.employeeCode,
				}).then(({ data, success }) => {
					showLoador({ loador: false });
					if (success) {
						if (!data.data.error) {
							showNotification({
								msg: data.data.message,
								severity: "error",
							});
						}
						return data.data.error;
					}
					return false;
				});
				return response;
			} else {
				showNotification({ msg: noInternetMsg, severity: "error" });
			}
		}
		return true;
	};
	//Comment by tejas for reference 27-03-2026

	// formatForSaveMethod = (dataToSave) => {
	//   const { latitude, longitude, address, stockStakeHolderTypeUserType } = this.state;

	//   let modifiedDataToSave = { ...dataToSave };

	//   if (ManagerJson.isEditURL != "" && dataToSave.id) {
	//     modifiedDataToSave = {
	//       ...modifiedDataToSave,
	//       stateId: Array.isArray(modifiedDataToSave.stateId) ? modifiedDataToSave.stateId.join(",") : modifiedDataToSave.stateId,
	//       regionIds: Array.isArray(modifiedDataToSave.regionIds) ? modifiedDataToSave.regionIds.join(",") : modifiedDataToSave.regionIds,
	//       latitude: latitude ?? dataToSave.latitude ?? null,
	//       longitude: longitude ?? dataToSave.longitude ?? null,
	//       homeAddress: address ?? dataToSave.homeAddress ?? null,
	//     }
	//   } else {
	//     modifiedDataToSave = {
	//       ...modifiedDataToSave,
	//       region: { id: modifiedDataToSave.regionIds },
	//       latitude: latitude ?? null,
	//       longitude: longitude ?? null,
	//       homeAddress: address ?? null,
	//     }
	//   }

	//   return modifiedDataToSave;

	// }

	formatForSaveMethod = (dataToSave) => {
		const { latitude, longitude, address } = this.state;

		const isEdit = ManagerJson.isEditURL !== "" && dataToSave.id;

		const locationFields = {
			latitude: latitude ?? (isEdit ? dataToSave.latitude : null) ?? null,
			longitude: longitude ?? (isEdit ? dataToSave.longitude : null) ?? null,
			homeAddress: address ?? (isEdit ? dataToSave.homeAddress : null) ?? null,
		};

		const regionFields = isEdit
			? {
					stateId: Array.isArray(dataToSave.stateId)
						? dataToSave.stateId.join(",")
						: dataToSave.stateId,
					regionIds: Array.isArray(dataToSave.regionIds)
						? dataToSave.regionIds.join(",")
						: dataToSave.regionIds,
					region: {
						id: Array.isArray(dataToSave.regionIds)
							? dataToSave.regionIds.join(",")
							: dataToSave.regionIds,
					},
				}
			: { region: { id: dataToSave.regionIds } };

		return { ...dataToSave, ...locationFields, ...regionFields };
	};

	getCurrentLocationData = () => {
		const success = (position) => {
			const latitude = position.coords.latitude;
			const longitude = position.coords.longitude;
			this.setAddressData(latitude, longitude);

			this.setState({
				latitude: latitude,
				longitude: longitude,
			});
			return { latitude: latitude, longitude: longitude };
		};

		const error = () => {
			this.setState({
				latitude: "",
				longitude: "",
			});
			return "";
		};

		navigator.geolocation.getCurrentPosition(success, error);
	};

	getLocation = (latitude, longitude) => {
		this.setAddressData(latitude, longitude);

		this.setState({
			openMap: false,
			latitude: latitude,
			longitude: longitude,
		});
	};

	onSaveLocation = () => {
		this.setState({
			openMap: true,
		});
	};

	onRadioChange = (e) => {
		const { value } = e.target;
		this.setState({
			locationValue: value,
		});
		if (value == 1) {
			this.getCurrentLocationData();
		}
	};

	changeLocation = () => {
		const { latitude, longitude } = this.state;
		if (latitude == "" && longitude == "") {
			this.getCurrentLocationData();
		}
		this.setState({
			showLocation: true,
			locationValue: "",
		});
	};

	onCloseMap = () => {
		this.setState({
			openMap: false,
		});
	};

	setAddressData = (latitude, longitude) => {
		const { showLoador } = this.props;
		if (googleApiKey !== null) {
			if (latitude !== null && longitude !== null) {
				showLoador({ loador: true });
				const apiUrl = `${googleAddressUrl}${latitude},${longitude}&key=${googleApiKey}`;

				fetch(apiUrl)
					.then((response) => response.json())
					.then((data) => {
						showLoador({ loador: false });

						if (data.status === "OK" && data.results.length !== 0) {
							const fetchedAddress = data.results[0].formatted_address;
							this.setState({ address: fetchedAddress });
						} else {
							console.error("Error:", data.status);
						}
					})
					.catch((error) => {
						showLoador({ loador: false });
						console.error("Error:", error);
					});
			}
		}
	};

	onCancel = () => {
		this.props.navigate(-1);
	};

	render() {
		const {
			dynamicMasterData,
			openMap,
			latitude,
			longitude,
			showLocation,
			locationValue,
			isShowSalesTeamModuleOverTheManager,
			stockStakeHolderTypeUserType,
			address,
			isShowSalesTeamHomeAddress,
		} = this.state;

		let isShowLeaveAndClaimAuthorityType =
			localStorage.getItem("isShowLeaveAndClaimAuthorityType") &&
			localStorage.getItem("isShowLeaveAndClaimAuthorityType") == 1;

		let isSalesTeamTypeDisabledOnEdit =
			localStorage.getItem("isSalesTeamTypeDisabledOnEdit") &&
			localStorage.getItem("isSalesTeamTypeDisabledOnEdit") == 1;

		let multipleRegionForManager =
			localStorage.getItem("multipleRegionForManager") &&
			localStorage.getItem("multipleRegionForManager") == 1;

		let showTargetTypeRadioGroup =
			localStorage.getItem("showTargetTypeRadioGroup") &&
			localStorage.getItem("showTargetTypeRadioGroup") == 1;

		let showDateOfJoining =
			localStorage.getItem("isShowDojAtSalesTeam") &&
			localStorage.getItem("isShowDojAtSalesTeam") == 1;

		let showCompanyFlagOfFoodrite =
			localStorage.getItem("showCompanyFlag") &&
			localStorage.getItem("showCompanyFlag") == 4;

		let showOutletEdit =
			localStorage.getItem("isShowOutletEditAndSequenceWiseOrder") &&
			localStorage.getItem("isShowOutletEditAndSequenceWiseOrder") == 1;

		const baseFieldMeta = multipleRegionForManager
			? showDateOfJoining
				? ManagerJson.fieldMeta
				: ManagerJson.fieldMetaWithoutDoj
			: showDateOfJoining
				? ManagerJson.fieldMetaWithSingleRegion
				: ManagerJson.fieldMetaWithSingleRegionWithoutDoj;

		// Apply override condition
		const finalFieldMeta =
			multipleRegionForManager && stockStakeHolderTypeUserType === 4
				? baseFieldMeta.map((field) =>
						field.dataKey === "regionIds"
							? { ...field, controlType: "autocomplete" }
							: field,
					)
				: baseFieldMeta;

		const outletEditField = ManagerJsonForFoodrite.fieldMetaForManager.find(
			(field) => field.dataKey === "outletEdit",
		);

		const applyOutletEditToFieldMeta = (fields) => {
			const fieldsWithoutOutletEdit = fields.filter(
				(field) => field.dataKey !== "outletEdit",
			);

			if (!showOutletEdit) {
				return fieldsWithoutOutletEdit;
			}

			const sequenceIndex = fieldsWithoutOutletEdit.findIndex(
				(field) => field.dataKey === "sequenceWiseOrder",
			);
			const insertIndex =
				sequenceIndex !== -1 ? sequenceIndex + 1 : fieldsWithoutOutletEdit.length;

			return [
				...fieldsWithoutOutletEdit.slice(0, insertIndex),
				outletEditField,
				...fieldsWithoutOutletEdit.slice(insertIndex),
			];
		};

		//Final Field Meta (Foodrite condition)
		const fieldMeta = showCompanyFlagOfFoodrite
			? stockStakeHolderTypeUserType === 4
				? ManagerJsonForFoodrite.fieldMetaForSR
				: ManagerJsonForFoodrite.fieldMetaForManager
			: applyOutletEditToFieldMeta(finalFieldMeta);

		return (
			<>
				{!openMap ? (
					<>
						<Paper
							sx={{
								p: 2,
								pt: 2,
								borderRadius: 2,
							}}
							elevation={0}
						>
							<LandingScreenHeader
								screenTitle={
									isShowSalesTeamModuleOverTheManager
										? ManagerJson.screenTitleForSalesTeam
										: ManagerJson.screenTitle
								}
								showTable={false}
								showBackButton={true}
								showAddButton={false}
								onCancel={this.onCancel}
							/>

							{isShowSalesTeamHomeAddress && (
								<LocationRow
									id={this.props.params.id}
									showLocation={showLocation}
									locationValue={locationValue}
									latitude={latitude}
									longitude={longitude}
									onChangeLocation={this.changeLocation}
									onRadioChange={this.onRadioChange}
									onSaveLocation={this.onSaveLocation}
									address={address}
									addressTitle="Home Address"
								/>
							)}

							<DynamicForm
								callBeforeSave={true}
								callBeforeSaveMethod={this.callBeforeSaveMethod}
								formPath={ManagerJson.formPath}
								getListById={this.getListById}
								isShowPaymentReminderMarquee={false}
								screenTitle={""}
								getDataForm={true}
								setDataToForm={this.setDataToForm}
								fieldMeta={fieldMeta}
								dynamicMasterData={dynamicMasterData}
								apiBaseURL={ManagerJson.apiBaseURL}
								showSaveNextBtn={ManagerJson.showSaveNextBtn}
								isEditURL={ManagerJson.isEditURL}
								isLog={true}
								type={1}
								formatForSave={
									isShowSalesTeamModuleOverTheManager == 1 &&
									stockStakeHolderTypeUserType == 4
										? true
										: false
								}
								formatForSaveMethod={this.formatForSaveMethod}
								showBackToList={false}
							/>
						</Paper>
					</>
				) : (
					<>
						<Paper elevation={0}>
							<GoogleMapForAreaExploration
								getLocation={this.getLocation}
								setLocation={{
									latitude: latitude,
									longitude: longitude,
								}}
								closeMap={this.onCloseMap}
								address={address}
							/>
						</Paper>
					</>
				)}
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	zoneList: state.zone,
	stockStakeHolderTypeList: state.stockStakeHolderType,
	salesExecutiveList: state.salesExecutive,
	regionList: state.region,
	stateList: state.states,
	districtList: state.district,
	talukaList: state.taluka,
	areaList: state.area,
});

const mapDispatchToProps = {
	getRegionNew,
	getZoneByRegion,
	getAreaByStockStakeHolderTypeIdAndZoneIds,
	getAreaByStockStakeHolderTypeIdAndZoneIdsEdit,
	getStockStakeHolderType,
	getAboveOrderAndSelfById,
	getAboveOrderById,
	getSalesExecutiveByAreaAndStockHolderType,
	getSalesExecutiveByAreaAndStockHolderTypeForLeave,
	getSalesExecutiveByAreaAndStockHolderTypeForClaim,
	getStateByRegion,
	getZoneByState,
	getDistrictByZone,
	getTalukaByDistrictPost,
	getAreaByTalukaPostBodyUpdated,
	showLoador,
	showNotification,
};
export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(ManagerForm);
